module.exports = __webpack_public_path__ + "img/risk_img_indoor@3x.a6d62b34.png";